'use client';

import { IResource } from '@gettactic/api';
import React from 'react';
import {
  MapCanvasProvider,
  MapCanvasValue
} from './components/map/contexts/MapCanvasContext';
import {
  MapEditorProvider,
  MapEditorState
} from './components/map/contexts/MapEditorContext';
import { MapEditor } from './components/map/editor/MapEditor';
import { EditorShortcutProvider } from './components/map/editor/shortcuts/EditorShortcutContext/EditorShortcutContext';
import { shortcuts } from './components/map/editor/shortcuts/shortcuts';
import { MapCurrentPosition, ResourceEditingOptions } from './types';

export interface MapBuilderProps {
  onSave: (data: MapCanvasValue) => void;
  value?: MapCanvasValue;
  resources?: IResource[];
  initialPosition?: MapCurrentPosition;
  setEditingResources: (value: ResourceEditingOptions) => void;
  editingResources?: ResourceEditingOptions;
  editorRef?: React.RefObject<MapEditorState | null | undefined>;
}

export const MapBuilder: React.FC<MapBuilderProps> = (props) => {
  const {
    value,
    resources,
    initialPosition,
    setEditingResources,
    editingResources,
    onSave,
    editorRef
  } = props;

  const [fontLoaded, setFontLoaded] = React.useState(false);

  React.useEffect(() => {
    const link = document.createElement('link');
    link.href =
      'https://fonts.googleapis.com/css2?family=Quicksand:wght@300;700&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);

    document.fonts.load('16px Quicksand').then(() => {
      setFontLoaded(true);
    });
  }, []);

  if (!fontLoaded) return;

  return (
    <MapCanvasProvider value={value} initialPosition={initialPosition}>
      <MapEditorProvider
        resources={resources}
        setEditingResources={setEditingResources}
        editingResources={editingResources}
        editorRef={editorRef}
        onSave={onSave}
      >
        <EditorShortcutProvider defaultShortcuts={shortcuts}>
          <MapEditor onSave={onSave} />
        </EditorShortcutProvider>
      </MapEditorProvider>
    </MapCanvasProvider>
  );
};
